import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTypography = styled(Typography)(({ theme }) => ({
  '&': {
    color: 'black',
    fontSize: '13px',
    fontWeight: 400,
  },
}));

// ----------------------------------------------------------------------

MyDownlineTableRow.propTypes = {
  row: PropTypes.object,
};

export default function MyDownlineTableRow({ row }) {
  const {
    tier, // cnt, commission, profit,
    referred_members: referredMembers,
  } = row;

  return (
    <>
      <TableRow>
        <TableCell rowSpan={referredMembers.length + 1}>
          <StyledTypography sx={{ color: '#FF9D00 !important' }}>{tier}</StyledTypography>
        </TableCell>
        {referredMembers.length <= 0 && (
          <TableCell>{<StyledTypography sx={{ color: '#FF9D00 !important' }}>-</StyledTypography>}</TableCell>
        )}
      </TableRow>
      {referredMembers.map((item, index) => (
        <TableRow key={index}>
          <TableCell>
            <StyledTypography sx={{ color: '#FF9D00 !important' }}>{item}</StyledTypography>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
